import { useEffect, useState } from 'react';

import { Box, CircularProgress } from '@mui/material';

const SHOW_DELAY_MS = 300;

// Fills the viewport while the app waits on something it cannot render without
// (sign-in, a login redirect). Stays invisible for the first moments so fast
// paths don't flash a spinner.
function FullPageLoader() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => clearTimeout(id);
  }, []);

  return (
    <Box
      data-testid="full-page-loader"
      aria-busy="true"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      {visible && <CircularProgress />}
    </Box>
  );
}

export default FullPageLoader;
